import { getDateString, today } from "./core";

/**
 * Get a valid date from URL parameter or fall back to a default (today's date).
 * @param {string|null} urlDate - Date from URL parameter in YYYY-MM-DD format
 * @param {string|null} defaultDate - Default date to use if URL date is invalid (optional)
 * @returns {string} Valid date string in YYYY-MM-DD format
 */
export function getValidDateFromUrl(urlDate, defaultDate = null) {
  if (urlDate) {
    // Validate the URL date format (YYYY-MM-DD)
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (dateRegex.test(urlDate)) {
      // Try to create a date object to ensure it's a valid date
      const testDate = new Date(urlDate + "T00:00:00");
      if (!isNaN(testDate.getTime())) {
        return urlDate;
      }
    }
  }
  return defaultDate || getDateString(today());
}
